module.exports = __webpack_public_path__ + "img/bubble2-active.6df0cce2.svg";